import { Outlet, NavLink, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, Package, ShoppingCart, Users, Ticket, FileText, Settings, LogOut, Droplets, ArrowLeft, ShieldCheck, CreditCard, ReceiptText, Image, Layout, MessageCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";

const NAV = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true, perm: "dashboard.view" },
  { to: "/admin/products", label: "Products", icon: Package, perm: "products.view" },
  { to: "/admin/orders", label: "Orders", icon: ShoppingCart, perm: "orders.view" },
  { to: "/admin/payments", label: "Payments", icon: CreditCard, perm: "payments.view" },
  { to: "/admin/billing", label: "Billing & Invoices", icon: ReceiptText, perm: "invoices.view" },
  { to: "/admin/customers", label: "Customers", icon: Users, perm: "customers.view" },
  { to: "/admin/coupons", label: "Coupons", icon: Ticket, perm: "coupons.view" },
  { to: "/admin/page-builder", label: "Page Builder", icon: Layout, perm: "cms.view" },
  { to: "/admin/content", label: "Content & CMS", icon: FileText, perm: "cms.view" },
  { to: "/admin/media", label: "Media Library", icon: Image, perm: "media.manage" },
  { to: "/admin/whatsapp", label: "WhatsApp", icon: MessageCircle, perm: "whatsapp.view" },
  { to: "/admin/more", label: "Settings", icon: Settings, perm: null },
];

export default function AdminLayout() {
  const { user, logout, can } = useAuth();
  const navigate = useNavigate();
  const nav = NAV.filter((n) => !n.perm || can(n.perm));
  return (
    <div className="min-h-screen bg-slate-950 text-slate-200 flex">
      <aside className="w-16 lg:w-60 bg-navy border-r border-white/10 flex flex-col shrink-0">
        <Link to="/admin" className="h-16 flex items-center gap-2 px-4 border-b border-white/10">
          <span className="w-8 h-8 rounded-lg bg-white/10 flex items-center justify-center shrink-0"><Droplets className="w-4 h-4 text-teal-500" /></span>
          <span className="font-heading font-bold text-white text-sm hidden lg:block">WBG Admin</span>
        </Link>
        <nav className="flex-1 py-3 px-2 space-y-1">
          {nav.map((n) => {
            const Icon = n.icon;
            return (
              <NavLink key={n.to} to={n.to} end={n.end} data-testid={`admin-nav-${n.label.toLowerCase().split(" ")[0]}`}
                className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium ${isActive ? "bg-teal text-white" : "text-slate-400 hover:bg-white/5 hover:text-white"}`}>
                <Icon className="w-4 h-4 shrink-0" /> <span className="hidden lg:block">{n.label}</span>
              </NavLink>
            );
          })}
        </nav>
        <div className="p-2 border-t border-white/10 space-y-1">
          <div className="px-3 py-2 hidden lg:flex items-center gap-2 text-[11px] text-slate-500">
            <ShieldCheck className="w-3 h-3 text-teal-500" /> {user?.role?.replace("_", " ")}
          </div>
          <Link to="/" className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-slate-400 hover:bg-white/5"><ArrowLeft className="w-4 h-4 shrink-0" /><span className="hidden lg:block">Storefront</span></Link>
          <button onClick={async () => { await logout(); navigate("/"); }} className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-red-400 hover:bg-red-500/10" data-testid="admin-logout"><LogOut className="w-4 h-4 shrink-0" /><span className="hidden lg:block">Logout</span></button>
        </div>
      </aside>
      <div className="flex-1 min-w-0">
        <header className="h-16 border-b border-white/10 flex items-center justify-between px-6 bg-slate-900">
          <span className="text-sm text-slate-400">Water Business Guru — Command Center</span>
          <span className="text-sm text-white font-medium">{user?.name} <span className="text-xs text-teal-400">({user?.role})</span></span>
        </header>
        <main className="p-6 max-w-[1400px]"><Outlet /></main>
      </div>
    </div>
  );
}
